import { Component } from '@angular/core'

@Component({
  selector: 'se-po-contact-info-docs',
  templateUrl: './contact-info-docs.component.html',
  styleUrls: ['./contact-info-docs.component.scss'],
  standalone: false,
})
export class ContactInfoDocsComponent {
  public headers: string[] = [
    'Property',
    'Type',
    'Description',
  ]
  public contactInfoValueFields: any = [
    {
      Property: 'email',
      Type: 'string',
      Description: 'Email Address for Contact',
    },
    {
      Property: 'phone',
      Type: 'string',
      Description: 'Phone Number for Contact',
    }
  ]
}
